import RulesPage, { rulesQuery, PAGE_SIZE } from "@app/pages/rules/rules-page";
import type { rulesPage_Query } from "@app/queries/rulesPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/rules")({
  loader: () =>
    loadQuery<rulesPage_Query>(
      environment,
      rulesQuery,
      { limit: PAGE_SIZE },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Rules"),
  component: RulesRoute,
});

function RulesRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading rules</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading rules...</div>}
      >
        <RulesPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
